import React, { useState } from "react";
import { Box, Typography, useTheme, useMediaQuery, IconButton, Drawer } from "@mui/material";
import { Outlet } from "react-router-dom"; // Import Outlet
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import appConfig from "../config/appConfig"; // Import configuration
import MenuIcon from "@mui/icons-material/Menu";

const BaseLayout = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const sidebarWidth = 240;

  return (
    <Box sx={{ display: "flex", height: "100vh", overflow: "hidden" }}>
      {/* Mobile Drawer */}
      {isMobile && (
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', md: 'none' },
            '& .MuiDrawer-paper': { 
              boxSizing: 'border-box', 
              width: sidebarWidth,
              backgroundColor: theme.palette.background.paper,
            },
          }}
        >
          <Sidebar onClose={handleDrawerToggle} />
        </Drawer>
      )}

      {/* Desktop Sidebar */}
      {!isMobile && (
        <Box
          sx={{
            width: sidebarWidth,
            flexShrink: 0,
            display: { xs: 'none', md: 'block' },
          }}
        >
          <Sidebar />
        </Box>
      )}

      {/* Main Content Area */}
      <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          width: { xs: '100%', md: `calc(100% - ${sidebarWidth}px)` },
        }}
      >
        {/* Topbar */}
        <Topbar onMenuClick={handleDrawerToggle} />

        {/* Content Area */}
        <Box
          sx={{
            flexGrow: 1,
            overflowY: "auto",
            padding: { xs: 2, sm: 3 },
            marginTop: { xs: "56px", sm: "64px" }, // Adjust for mobile topbar height
            backgroundColor: "#f5f5f5",
            minHeight: { xs: "calc(100vh - 56px)", sm: "calc(100vh - 64px)" },
          }}
        >
          <Outlet />
        </Box>

        {/* Footer */}
        <Box
          sx={{
            backgroundColor: "#f0f0f0",
            borderTop: "1px solid #e0e0e0",
            textAlign: "center",
            padding: { xs: 1, sm: 2 },
            display: { xs: 'none', sm: 'block' }, // Hide footer on mobile to save space
          }}
        >
          <Typography variant="body2" color="textSecondary">
            © {new Date().getFullYear()} {appConfig.companyName}. Version{" "}
            {appConfig.version}.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default BaseLayout;
